export default __webpack_public_path__ + "static/media/4h.bc9b5af2.svg";